import React from "react";
import { Card, CardContent, Box, Typography, Button } from "@mui/material";
import football from "../Images/betkiff.JPG";

const BetCard = ({
  bet,
  hasUserBet,
  openBetModal,
  getSportIcon,
  formatDate,
  renderSettingsIcon,
  getUserBetAmount,
  getUserBetResult, // Fonction qui retourne "gagné", "perdu" ou null
}) => {
  const userResult = getUserBetResult(bet.id);
  console.log("userResult", userResult);

  return (
    <>
      <Card
        sx={{
          borderRadius: "25px",
          padding: "0px",
          marginBottom: "20px",
          boxShadow: "none",
        }}>
        <CardContent
          sx={{
            padding: "0",
            margin: "0",
            "&:last-child": {
              paddingBottom: "12px !important",
            },
          }}>
          <Box
            sx={{
              backgroundColor: "rgba(90,20,121,254)",
              position: "relative",
              padding: "10px",
            }}>
            <Box
              sx={{
                position: "absolute",
                left: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                display: "flex",
                alignItems: "center",
              }}>
              {bet.sportCategory === "octopearl" ? (
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "12px",
                    color: "white",
                    padding: "5px 10px",
                    borderRadius: "8px",
                  }}>
                  OctoPearl
                </span>
              ) : bet.sportCategory === "poulparty" ? (
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "12px",
                    color: "white",
                    padding: "5px 10px",
                    borderRadius: "8px",
                  }}>
                  PoulParty
                </span>
              ) : (
                getSportIcon(bet.sportCategory)
              )}
            </Box>

            <Typography
              variant="body2"
              sx={{
                color: "white",
                fontWeight: "bold",
                textAlign: "center",
              }}>
              {formatDate(bet.date, bet.time)}
            </Typography>
            {renderSettingsIcon(bet.id, "normal")}
          </Box>

          {/* Affichage de l'image :
              Si bet.imageBetUrl existe, on l'utilise, sinon on affiche l'image "football" par défaut. */}
          <img
            src={bet.imageBetUrl ? bet.imageBetUrl : football}
            alt="BetKiff Logo"
            style={{
              width: "100%",
              height: "150px",
              objectFit: "cover",
            }}
          />

          <Box
            sx={{
              padding: "0px 10px",
            }}>
            <Typography
              variant="h6"
              textAlign="center"
              sx={{
                color: "rgba(90,20,121,254)",
                fontWeight: "bold",
                lineHeight: 1,
                margin: "20px 20px 10px 20px",
              }}>
              {bet.team1} - {bet.team2}
            </Typography>

            <Typography
              variant="body2"
              color="text.secondary"
              textAlign="center"
              sx={{
                lineHeight: 1,
              }}>
              {bet.matchStatus === "pas encore"
                ? `Début du match à ${bet.time}`
                : `${bet.matchStatus ?? "N/A"}`}
              {bet.matchStatus !== "pas encore"
                ? ` | Score : ${bet.score.team1 ?? "N/A"} - ${
                    bet.score.team2 ?? "N/A"
                  }`
                : ""}
            </Typography>

            {/* 🔹 Affichage du résultat si les gains ont été distribués */}
          </Box>
          {/* </CardContent>
      </Card>
      <Card
        sx={{
          borderRadius: "25px",
          marginBottom: "20px",
          padding: "0px",
          boxShadow: "none",
        }}
      >
        <CardContent
          sx={{
            padding: "0",
            margin: "0",
            "&:last-child": {
              paddingBottom: "12Px !important",
            },
          }}
        > */}
          <Box
            sx={{
              padding: "10px 10px 0px 10px",
            }}>
            {bet.distributeWinningDone && userResult ? (
              <Box sx={{ textAlign: "left" }}>
                {userResult.status === "gagné" ? (
                  <Typography
                    variant="body2"
                    sx={{
                      color: "green",
                      fontWeight: "bold",
                    }}>
                    Vous avez gagné 🤙{userResult.winnings}
                  </Typography>
                ) : userResult.status === "perdu" ? (
                  <Typography
                    variant="body2"
                    sx={{
                      color: "red",
                      fontWeight: "bold",
                    }}>
                    Vous avez perdu 🤙{userResult.lostAmount}
                  </Typography>
                ) : null}
              </Box>
            ) : bet.bettingOpen ? (
              !hasUserBet(bet.id) ? (
                <Box>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    sx={{ gap: 0.4 }}>
                    {/* Boutons pour parier */}
                    <Button
                      variant="contained"
                      onClick={() =>
                        openBetModal(bet.id, "winTeam1", bet.odds.winTeam1)
                      }
                      sx={{
                        flex: 1,
                        backgroundColor: "rgba(225, 191, 228, 255)",
                        padding: "0",
                        borderRadius: "15px",
                        minWidth: 0, // Assure que le bouton ne s'agrandit pas trop
                      }}
                      aria-label={`Parier sur ${bet.team1}`}>
                      <Box
                        textAlign="center"
                        sx={{ width: "80%", overflow: "hidden" }}>
                        <Typography
                          variant="caption"
                          sx={{
                            color: "rgba(90,20,121,254)",
                            fontWeight: "bold",
                            fontSize: "0.5rem",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            display: "block",
                            maxWidth: "100%",
                          }}>
                          {bet.team1}
                        </Typography>

                        <Typography
                          variant="h6"
                          sx={{
                            color: "rgba(90,20,121,254)",
                            fontWeight: "bold",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            display: "block",
                            maxWidth: "100%",
                          }}>
                          {bet.odds.winTeam1}
                        </Typography>
                      </Box>
                    </Button>

                    <Button
                      variant="contained"
                      onClick={() =>
                        openBetModal(bet.id, "draw", bet.odds.draw)
                      }
                      sx={{
                        flex: 1,
                        backgroundColor: "rgba(225, 191, 228, 255)",
                        padding: "0",
                        borderRadius: "15px",
                        minWidth: 0, // Assure que le bouton ne s'agrandit pas trop
                      }}
                      aria-label={`Parier sur égalité`}>
                      <Box
                        textAlign="center"
                        sx={{ width: "80%", overflow: "hidden" }}>
                        <Typography
                          variant="caption"
                          sx={{
                            color: "rgba(90,20,121,254)",
                            fontWeight: "bold",
                            fontSize: "0.5rem",
                          }}>
                          Nul
                        </Typography>
                        <Typography
                          variant="h5"
                          sx={{
                            color: "rgba(90,20,121,254)",
                            fontWeight: "bold",
                          }}>
                          {bet.odds.draw}
                        </Typography>
                      </Box>
                    </Button>

                    <Button
                      variant="contained"
                      onClick={() =>
                        openBetModal(bet.id, "winTeam2", bet.odds.winTeam2)
                      }
                      sx={{
                        flex: 1,
                        backgroundColor: "rgba(225, 191, 228, 255)",
                        padding: "0",
                        borderRadius: "15px",
                        minWidth: 0, // Assure que le bouton ne s'agrandit pas trop
                      }}
                      aria-label={`Parier sur ${bet.team2}`}>
                      <Box
                        textAlign="center"
                        sx={{ width: "80%", overflow: "hidden" }}>
                        <Typography
                          variant="caption"
                          sx={{
                            color: "rgba(90,20,121,254)",
                            fontWeight: "bold",
                            fontSize: "0.5rem",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            display: "block",
                            maxWidth: "100%",
                          }}>
                          {bet.team2}
                        </Typography>
                        <Typography
                          variant="h5"
                          sx={{
                            color: "rgba(90,20,121,254)",
                            fontWeight: "bold",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            display: "block",
                            maxWidth: "100%",
                          }}>
                          {bet.odds.winTeam2}
                        </Typography>
                      </Box>
                    </Button>
                  </Box>
                </Box>
              ) : (
                <Typography color="text.secondary">
                  Montant parié : {getUserBetAmount(bet.id)} 🤙
                </Typography>
              )
            ) : (
              <Typography color="text.secondary">
                Les mises sont fermées pour ce match.
              </Typography>
            )}
          </Box>
        </CardContent>
      </Card>
    </>
  );
};

export default BetCard;
